import React from "react";
import { useNavigate, useLocation } from "react-router-dom";
import "./OrderSuccess.css";
import SuccessAnimation from "./components/SuccessAnimation";
import OrderIdCard from "./components/OrderIdCard";





import ActionButtons from "./components/ActionButtons";
import FooterMessage from "./components/FooterMessage";
const OrderSuccess = () => {
  const navigate = useNavigate();
  const location = useLocation();

  // Data passed from Checkout page
  const order = location.state?.order || {};

  const orderId =
    order.orderNumber ||
    order._id ||
    "HF1753898568123";

  const paymentMethod =
    order.paymentMethod ||
    "Cash On Delivery";

  const deliveryTime = "30 - 40 mins";

  const grandTotal =
    order.grandTotal ||
    order.totalPrice ||
    0;

  const address =
    order.addressSnapshot || {};

  return (
    <div className="order-success-page">

      {/* ================================= */}
      {/* Confetti */}
      {/* ================================= */}

      <div className="confetti-wrapper">

        {[...Array(40)].map((_, index) => (
          <span
            key={index}
            className={`confetti confetti-${index}`}
          />
        ))}

      </div>

      {/* ================================= */}
      {/* Main Card */}
      {/* ================================= */}

      <div className="success-card">

        {/* Success Animation */}

       <SuccessAnimation />

        {/* Heading */}

        <h1>

          Order Placed Successfully!

        </h1>

        <p className="success-message">

          Thank you for ordering with HomeFoods.

          <br />

          Your delicious homemade food is now being prepared.

        </p>

        {/* ================================= */}
        {/* Order ID */}
        {/* ================================= */}

        <OrderIdCard order={order} />

        {/* ================================= */}
        {/* ETA */}
        {/* ================================= */}

     {/* ================================= */}
        {/* Address */}
        {/* ================================= */}

 
        {/* ================================= */}
        {/* Payment */}
        {/* ================================= */}

 
        {/* ================================= */}
        {/* Total */}
        {/* ================================= */}

  
        {/* ================================= */}
        {/* Buttons */}
        {/* ================================= */}



<ActionButtons />
        {/* Footer */}

       <FooterMessage />

      </div>

    </div>
  );
};

export default OrderSuccess;